import React, {useEffect} from 'react';
import { useHash, useCookie } from 'react-use';
import { AmplifyAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import AmplifySignCom from './AmplifySignCom';
import './App.css';

const Sign = () => {
    const [hash, setHash] = useHash();
    const [idToken, updateIdToken, deleteIdToken] = useCookie("id_token");
    useEffect(() => {
        const unsubscribe = onAuthUIStateChange((state, authData) => {
            if(state === AuthState.SignedIn) {
                const token = authData.signInUserSession.idToken.jwtToken;
                if(idToken === null || idToken !== token) {
                    updateIdToken(token);
                }
                setTimeout(()=>{
                    window.location.href = "https://cbre.creis.jp/#/#id_token="+token;
                }, 500);
            }
        })
        
        return () => {
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        if (hash) {
            const query = hash.replace('#','');
            const tem = query.split('&');
            const token = tem.map((ee) => {
                if (ee) {
                    let a = ee.split('=');
                    return a[1];
                };
                return null;
            })

            if(token !== null) {
                signOut();
            }
        } 
    }, [])

    async function signOut() {
        try {
            deleteIdToken();
            await Auth.signOut();
        } catch (error) {
            //console.log('error signing out: ', error);
        }
    }

    return (<><div class="logo"><img src="https://cbredata.com/assets/images/logo-dark.png"></img></div>
        <AmplifyAuthenticator initialAuthState="signup">
            <AmplifySignCom />
        </AmplifyAuthenticator>
        </>
    );
};

export default Sign;
